/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { AnyAction } from '@reduxjs/toolkit';

import { WorkspaceStateSlice } from '../../../../ts/state';
import { SkillTrainingStatus } from '../../util/trainingStatusPollingMachine';
import * as actionTypes from './actionTypes';

const initialState: WorkspaceStateSlice = {
  tryitOpen: false,
  editPanelOpen: false,
  trainingState: SkillTrainingStatus.NONE,
  actionsTrainingState: SkillTrainingStatus.NONE
};

export const reducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case actionTypes.SET_TRYIT_STATE:
      return { ...state, tryitOpen: action.newState };
    case actionTypes.SKILL_IMPORTED:
      return { ...state, skillImported: action.imported };
    case actionTypes.SET_TRAINING_STATE:
      return {
        ...state,
        trainingState: action.newState,
        actionsTrainingState: action.newState
      };
    case actionTypes.SET_EDIT_PANEL_OPEN:
      return { ...state, editPanelOpen: action.isOpen };
    default: {
      return state;
    }
  }
};

export default reducer;
